import axios from 'axios'
import get from 'lodash/get'

export function resetAuthHeader() {
  axios.defaults.headers.common.Authorization = `Bearer: ${JSON.parse(
    localStorage.getItem('token')
  )}`
}

export function configureAxios() {
  axios.defaults.baseURL = process.env.API_URL
  axios.defaults.headers.post.Accept = 'application/json'
  axios.defaults.headers.post['Content-Type'] = 'application/json'
  resetAuthHeader()

  axios.interceptors.response.use(
    (response) => {
      const data = response.data
      return Promise.resolve(data)
    },
    (error) => {
      const errors = get(error, 'response.data.error.errors', null)
      let message = get(error, 'response.data.error.message', null)
      message = message || get(error, 'response.statusText', 'Unknown error')
      return Promise.reject({ message, errors })
    }
  )
}



// WEBPACK FOOTER //
// ./src/axios.js